var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entity-item",on:{"click":_vm.toEntity}},[_c('img',{attrs:{"src":_vm._f("logo_show")(_vm.itemDetail.logoPath)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }